import { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { actions } from '../../../../../context';

const PartnerSelector = () => {
    const [daylightPartnerOfferings, setDaylightPartnerOfferings] = useState(
        []
    );

    const practicePartnerOfferings = useSelector(
        (state) => state.practice.practice.practiceOfferings,
        shallowEqual
    );
    const partnerIdFilter = useSelector(
        (state) => state.daylight.partnerIdFilter,
        shallowEqual
    );

    useEffect(() => {
        const daylightPartnerOfferings = practicePartnerOfferings.filter(
            (partnerOffering) => partnerOffering.isDaylightOffering
        );
        setDaylightPartnerOfferings(daylightPartnerOfferings);
    }, [practicePartnerOfferings]);

    const dispatch = useDispatch();

    const setSelectedDaylightPartnerId = (partnerId) => {
        dispatch(actions.daylight.setSelectedPartnerId(partnerId));
        dispatch(actions.daylight.clearIncomingNeoCodes());
        dispatch(actions.daylight.refreshCodes());
        dispatch(actions.daylight.fetchIncomingNeoCodes());
    };

    return (
        <>
            <select
                onChange={(e) => setSelectedDaylightPartnerId(e.target.value)}
                value={partnerIdFilter || ''}>
                <option disabled value="">
                    Select Partner
                </option>
                {daylightPartnerOfferings.map((partnerOffering) => (
                    <option
                        key={partnerOffering.partnerId}
                        value={partnerOffering.partnerId}>
                        {partnerOffering.partner}
                    </option>
                ))}
            </select>
        </>
    );
};

export default PartnerSelector;
